import { Box, Typography, useColorScheme } from "@mui/material";
import { alpha } from '@mui/material/styles';
import { Constants } from "../../utils/constants";


export default function ActiveButton({ onClick = null, text = "Active" }) {
  const { mode } = useColorScheme();
  const currentMode = mode || "light";
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: alpha(Constants.Colors[currentMode].accent, 0.1),
        color: Constants.Colors[currentMode].accent,
        border: `1px solid ${alpha(Constants.Colors[currentMode].accent, 0.2)}`,
        borderRadius: "0.25rem",
        boxShadow: "none",
        textTransform: "none",
        cursor: onClick ? "pointer" : "unset",
        display: "inline-block",
        alignItems: "center",
        justifyContent: "center",
        padding: "0rem 0.5rem",
      }}
    >

      <Typography sx={{
        fontWeight: Constants.Styles.fontWeight.medium,
        fontSize: Constants.Styles.fontSize.xs,
        lineHeight: Constants.Styles.lineHeight.xs,
      }}>{text}</Typography>
    </Box>
  );
}
